<div>
  <button nz-button nzType="secondary" (click)="openFile()" [disabled]="documentKeys.length === 0">
    <i nz-icon nzType="printer" nzTheme="outline"></i><span>Drucken</span>
  </button>
</div>
